import { changeTheme } from 'owa-fabric-theme';
import { orchestrator } from 'satcheljs';
import enableNotesDarkMode from '../actions/enableDarkMode';

orchestrator(changeTheme, actionMessage => {
    const { isDarkTheme } = actionMessage;
    enableNotesDarkMode(isDarkTheme);
});
